import React from "react";
import { Link } from "react-router-dom";

export function PageHeader({ eyebrow, title, subtitle, actions, mascot }) {
  return (
    <div className="flex items-start justify-between gap-6 mb-8 flex-wrap">
      <div className="flex items-start gap-4">
        {mascot && (
          <img src={mascot} alt="" className="h-20 w-auto hidden sm:block vv-mascot-float" />
        )}
        <div>
          {eyebrow && (
            <div className="text-[11px] uppercase tracking-[0.3em] text-[hsl(var(--vv-lime))] mb-1">{eyebrow}</div>
          )}
          <h1 className="text-3xl sm:text-4xl font-black">{title}</h1>
          {subtitle && <p className="text-muted-foreground mt-1 max-w-xl">{subtitle}</p>}
        </div>
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

/**
 * StatCard — clickable when `to` (Link route) or `onClick` provided.
 */
export function StatCard({ label, value, hint, icon: Icon, color = "blue", testId, to, onClick }) {
  const colorMap = {
    blue: "text-[hsl(var(--vv-blue))]",
    yellow: "text-[hsl(var(--vv-yellow))]",
    lime: "text-[hsl(var(--vv-lime))]",
    red: "text-destructive",
  };
  const isInteractive = !!(to || onClick);
  const inner = (
    <>
      <div className="flex items-center justify-between mb-2">
        <div className="text-xs uppercase tracking-widest text-muted-foreground">{label}</div>
        {Icon && <Icon className={`size-5 ${colorMap[color]}`} />}
      </div>
      <div className={`text-4xl font-black ${colorMap[color]}`}>{value}</div>
      {hint && <div className="text-xs text-muted-foreground mt-1">{hint}</div>}
      {isInteractive && (
        <div className="text-[10px] uppercase tracking-widest text-muted-foreground mt-2 flex items-center gap-1">
          <span>Ver detalhes</span>
          <span className="text-[hsl(var(--vv-lime))]">→</span>
        </div>
      )}
    </>
  );
  const cls = `vv-stat block w-full text-left ${isInteractive ? "cursor-pointer hover:scale-[1.02]" : ""}`;
  if (to) return <Link to={to} className={cls} data-testid={testId}>{inner}</Link>;
  if (onClick) return <button type="button" onClick={onClick} className={cls} data-testid={testId}>{inner}</button>;
  return <div className={cls} data-testid={testId}>{inner}</div>;
}

export function EmptyState({ title, description, mascot, action }) {
  return (
    <div className="vv-card p-10 flex flex-col items-center text-center">
      {mascot && <img src={mascot} alt="" className="h-44 mb-4 vv-mascot-float" />}
      <h3 className="text-xl font-black">{title}</h3>
      {description && <p className="text-sm text-muted-foreground mt-2 max-w-md">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
